/**
 * DataTableCellProcessStatus class
 *
 * @package    DataTable
 * @author     Roman Kritskiy <rkirtskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { DataTableColumnType, DataTableItemType } from 'Types';
import Tooltip from '@material-ui/core/Tooltip';
import InfoIcon from '@material-ui/icons/Info';

import {PROCESS_STATUSES} from 'Constants';

export default class DataTableCellProcessStatus extends PureComponent {
    /**
     * PropTypes
     */
    static propTypes = {
        column: DataTableColumnType,
        value: PropTypes.any,
        item: DataTableItemType.isRequired,
    };

    /**
     * Render tooltip
     *
     * @returns {string}
     */
    renderTooltip = () => {
        const { item } = this.props;
        return item.process_status === 1 && item.result && item.result.comment ? (
            <Tooltip title={item.result.comment} placement="top">
                <InfoIcon />
            </Tooltip>
        ) : '';
    };

    /**
     * Render status label
     *
     * @returns {string}
     */
    renderStatusLabel = () => {
        const {
            item: { process_status },
        } = this.props;

        return PROCESS_STATUSES[process_status];
    };

    /**
     * Render
     *
     * @return {*}
     */
    render() {
        return (
            <div className={'status-cell'}>
                {this.renderStatusLabel()}
                {this.renderTooltip()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/DataTable/DataTableBody/DataTableCells/DataTableCellProcessStatus.jsx